import { render, staticRenderFns } from "./CreateVars.vue?vue&type=template&id=0d807055"
import script from "./CreateVars.vue?vue&type=script&lang=js"
export * from "./CreateVars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports